import { useState } from "react";
import { useEffect } from "react";
export default function AplicationStatus({status,setStatus,percent,setPercent, editData }) {
    const [isSmall, setIsSmall] = useState(window.innerWidth <= 900);
    const [aplicationStatus, setAplicationStatus] = useState("active");
useEffect(() => {
  if (editData?.status) {
    setStatus(editData.status);
    setAplicationStatus(editData.aplication_status);
    setPercent(String(editData.percent));
  }
}, [editData]);
  return (
    <div className="aplicationStatus">
      <select
        name="aplication_status"
        value={aplicationStatus}
        onChange={(e) => setAplicationStatus(e.target.value)}
      >
        <option value="active">ԱԿՏԻՎ</option>
        <option value="passive">ՊԱՍԻՎ</option>
        <option value="archive">ԱՐԽԻՎ</option>
      </select>

      <select
  	name="status"
  	value={status}
  	onChange={(e) => setStatus(e.target.value)}
	>
        <option value="regular">ՌԵԳՈՒԼՅԱՐ</option>
        <option value="exclusive">ԷՔՍԿԼՅՈՒԶԻՎ</option>
        <option value="document_exclusive">ՊԱՅՄԱՆԱԳՐՈՎ ԷՔՍԿԼՅՈՒԶԻՎ</option>
      </select>
	  {status === "document_exclusive" && <select
            name="percent"
            value={percent}
            onChange={(e) => setPercent(e.target.value)}>
        	<option value="0">ՄԻՋՆՈՐԴԱՎՃԱՐ</option>
        	<option value="2">2% ՄԻՋՆՈՐԴԱՎՃԱՐ</option>
        	<option value="4">4% ՄԻՋՆՈՐԴԱՎՃԱՐ</option>
      </select>}	  
    </div>
  );
}
